(function(app) {
    app.constant("phoneNumberTypes",
    [
        "Home",
        "Cell",
        "Business",
        "Fax",
        //"Isdn",
        "Other"
        //"Extension"
    ]);
})(window.app); //jshint ignore:line